import { MutationHookOptions, TypedDocumentNode, useMutation } from '@apollo/client';

export const createUseMutation =
  <TData = Record<string, any>, TVariables = Record<string, any>>(mutation: TypedDocumentNode<TData, TVariables>) =>
  (options?: MutationHookOptions<TData, TVariables>) =>
    useMutation<TData, TVariables>(mutation, options);
